import React from 'react';
import { Box } from '@chakra-ui/react';
import { surveyTheme as theme } from './surveyTheme';

/**
 * ProgressBar - Subtle, honest progress indicator
 *
 * Just a thin bar at the top. No percentage, no gamification.
 * Shows progress without making it a game.
 */
const ProgressBar = ({ current, total }) => {
  const progress = total > 0 ? ((current + 1) / total) * 100 : 0;

  return (
    <Box
      width="100%"
      height="3px"
      bg={theme.colors.borderLight}
      overflow="hidden"
    >
      <Box
        height="100%"
        bg={theme.colors.teal}
        width={`${progress}%`}
        transition={`width ${theme.transitions.slow}`}
        borderRadius={theme.radii.progress}
      />
    </Box>
  );
};

export default ProgressBar;
